module.exports = __webpack_public_path__ + "img/1030.d0bc7aed.png";